import React from 'react';

const FacebookPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fab fa-facebook-f"></i>
          Facebook - Marco De Marco
        </h1>
        <p>Connect with me on Facebook for family updates, photos, and personal stories.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="social-content">
            <p className="welcome-text">
              Facebook is where I share family moments, celebrate milestones, and
              connect with friends and relatives. It's a place for more personal
              updates and behind-the-scenes glimpses into our family life.
            </p>

            {/* Facebook Page Embed */}
            <div className="facebook-embed">
              <h3>My Facebook Profile</h3>
              <div className="social-embed-container">
                <div className="facebook-plugin">
                  <iframe
                    src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmarco.demarco&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                    width="500"
                    height="500"
                    style={{border: 'none', overflow: 'hidden'}}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen={true}
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    title="Facebook Page"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* What to Expect */}
            <div className="content-preview">
              <h3>What You'll Find on My Facebook</h3>
              <div className="social-features">
                <div className="feature-item">
                  <i className="fas fa-camera"></i>
                  <h4>Family Photos</h4>
                  <p>Recent family gatherings, celebrations, and everyday moments</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-calendar-check"></i>
                  <h4>Event Updates</h4>
                  <p>Information about family events, reunions, and special occasions</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-heart"></i>
                  <h4>Personal Stories</h4>
                  <p>Reflections on family, heritage, and life experiences</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-comments"></i>
                  <h4>Community</h4>
                  <p>Connecting with friends, family, and the local community</p>
                </div>
              </div>
            </div>

            {/* Direct Link */}
            <div className="social-link-section">
              <h3>Visit My Facebook Profile</h3>
              <a 
                href="https://www.facebook.com/marco.demarco" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-platform-link facebook-link"
              >
                <i className="fab fa-facebook-f"></i>
                Visit Facebook Profile
              </a>
              <p className="link-description">
                Click above to visit my Facebook profile directly and connect with me there.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacebookPage;